import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all.sort((a, b) => {
    return (a.update > b.update ? -1 : 1);
  })
}

const actions = {
  add ({ commit }, place) {
    commit('addPlace', place)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  addPlace (state, place) {
    const index = state.all.findIndex(h => h.name === place.name)
    if (index !== -1) {
      state.all = state.all.filter(h => h.name !== place.name)
    }
    const today = moment()
    const addPlace = Object.assign(place, { update: today.unix() })
    state.all.push(addPlace)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
